/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */

export enum ISOs {
  ATA = 'ATA',
  AUT = 'AUT',
  CAN = 'CAN',
  CHE = 'CHE',
  CZE = 'CZE',
  DEU = 'DEU',
  ESP = 'ESP',
  FRA = 'FRA',
  GBR = 'GBR',
  IDN = 'IDN',
  JPN = 'JPN',
  KOR = 'KOR',
  MYS = 'MYS',
  NLD = 'NLD',
  NZL = 'NZL',
  POL = 'POL',
  PRT = 'PRT',
  ROU = 'ROU',
  SGP = 'SGP',
  THA = 'THA',
  TWN = 'TWN',
  USA = 'USA',
  ZAF = 'ZAF',
  AQ = 'ATA',
  AT = 'AUT',
  CA = 'CAN',
  CH = 'CHE',
  CZ = 'CZE',
  DE = 'DEU',
  ES = 'ESP',
  FR = 'FRA',
  GB = 'GBR',
  ID = 'IDN',
  JP = 'JPN',
  KR = 'KOR',
  MY = 'MYS',
  NL = 'NLD',
  NZ = 'NZL',
  PL = 'POL',
  PT = 'PRT',
  RO = 'ROU',
  SG = 'SGP',
  TH = 'THA',
  TW = 'TWN',
  US = 'USA',
  ZA = 'ZAF',
}

export enum RegionToISOs {
  AQ = ISOs.ATA,
  AT = ISOs.AUT,
  CA = ISOs.CAN,
  CH = ISOs.CHE,
  CZ = ISOs.CZE,
  DE = ISOs.DEU,
  ES = ISOs.ESP,
  FR = ISOs.FRA,
  GB = ISOs.GBR,
  ID = ISOs.IDN,
  JP = ISOs.JPN,
  KR = ISOs.KOR,
  MY = ISOs.MYS,
  NL = ISOs.NLD,
  NZ = ISOs.NZL,
  PL = ISOs.POL,
  PT = ISOs.PRT,
  RO = ISOs.ROU,
  SG = ISOs.SGP,
  TH = ISOs.THA,
  TW = ISOs.TWN,
  US = ISOs.USA,
  ZA = ISOs.ZAF,
}

export enum ISOsToRegions {
  ATA = 'AQ',
  AUT = 'AT',
  CAN = 'CA',
  CHE = 'CH',
  CZE = 'CZ',
  DEU = 'DE',
  ESP = 'ES',
  FRA = 'FR',
  GBR = 'GB',
  IDN = 'ID',
  JPN = 'JP',
  KOR = 'KR',
  MYS = 'MY',
  NLD = 'NL',
  NZL = 'NZ',
  POL = 'PL',
  PRT = 'PT',
  ROU = 'RO',
  SGP = 'SG',
  THA = 'TH',
  TWN = 'TW',
  USA = 'US',
  ZAF = 'ZA',
}

export enum PaymentISOs {
  AQ = 'AQ',
  AT = 'AT',
  CA = 'CA',
  CH = 'CH',
  CZ = 'CZ',
  DE = 'DE',
  ES = 'ES',
  FR = 'FR',
  GB = 'GB',
  ID = 'ID',
  JP = 'JP',
  KR = 'KR',
  MY = 'MY',
  NL = 'NL',
  NZ = 'NZ',
  PL = 'PL',
  PT = 'PT',
  RO = 'RO',
  SG = 'SG',
  TH = 'TH',
  TW = 'TW',
  US = 'US',
  ZA = 'ZA',
}

export enum Currencies {
  CAD = 'CAD',
  CHF = 'CHF',
  CZK = 'CZK',
  EUR = 'EUR',
  GBP = 'GBP',
  IDR = 'IDR',
  JPY = 'JPY',
  KRW = 'KRW',
  MYR = 'MYR',
  NZD = 'NZD',
  PLN = 'PLN',
  RON = 'RON',
  SGD = 'SGD',
  THB = 'THB',
  TWD = 'TWD',
  USD = 'USD',
  ZAR = 'ZAR',
}

export const BILLING_COUNTRIES = {
  [ISOs.ATA]: { countryCode: PaymentISOs.AQ, currencyCode: Currencies.USD, currencyNumber: 840 },
  [ISOs.AUT]: { countryCode: PaymentISOs.AT, currencyCode: Currencies.EUR, currencyNumber: 978 },
  [ISOs.CAN]: { countryCode: PaymentISOs.CA, currencyCode: Currencies.CAD, currencyNumber: 124 },
  [ISOs.CHE]: { countryCode: PaymentISOs.CH, currencyCode: Currencies.CHF, currencyNumber: 756 },
  [ISOs.CZE]: { countryCode: PaymentISOs.CZ, currencyCode: Currencies.CZK, currencyNumber: 203 },
  [ISOs.DEU]: { countryCode: PaymentISOs.DE, currencyCode: Currencies.EUR, currencyNumber: 978 },
  [ISOs.ESP]: { countryCode: PaymentISOs.ES, currencyCode: Currencies.EUR, currencyNumber: 978 },
  [ISOs.FRA]: { countryCode: PaymentISOs.FR, currencyCode: Currencies.EUR, currencyNumber: 978 },
  [ISOs.GBR]: { countryCode: PaymentISOs.GB, currencyCode: Currencies.GBP, currencyNumber: 826 },
  [ISOs.IDN]: { countryCode: PaymentISOs.ID, currencyCode: Currencies.IDR, currencyNumber: 360 },
  [ISOs.JPN]: { countryCode: PaymentISOs.JP, currencyCode: Currencies.JPY, currencyNumber: 392 },
  [ISOs.KOR]: { countryCode: PaymentISOs.KR, currencyCode: Currencies.KRW, currencyNumber: 410 },
  [ISOs.MYS]: { countryCode: PaymentISOs.MY, currencyCode: Currencies.MYR, currencyNumber: 458 },
  [ISOs.NLD]: { countryCode: PaymentISOs.NL, currencyCode: Currencies.EUR, currencyNumber: 978 },
  [ISOs.NZL]: { countryCode: PaymentISOs.NZ, currencyCode: Currencies.NZD, currencyNumber: 554 },
  [ISOs.POL]: { countryCode: PaymentISOs.PL, currencyCode: Currencies.PLN, currencyNumber: 985 },
  [ISOs.PRT]: { countryCode: PaymentISOs.PT, currencyCode: Currencies.EUR, currencyNumber: 978 },
  [ISOs.ROU]: { countryCode: PaymentISOs.RO, currencyCode: Currencies.RON, currencyNumber: 946 },
  [ISOs.SGP]: { countryCode: PaymentISOs.SG, currencyCode: Currencies.SGD, currencyNumber: 702 },
  [ISOs.THA]: { countryCode: PaymentISOs.TH, currencyCode: Currencies.THB, currencyNumber: 764 },
  [ISOs.TWN]: { countryCode: PaymentISOs.TW, currencyCode: Currencies.TWD, currencyNumber: 901 },
  [ISOs.USA]: { countryCode: PaymentISOs.US, currencyCode: Currencies.USD, currencyNumber: 840 },
  [ISOs.ZAF]: { countryCode: PaymentISOs.ZA, currencyCode: Currencies.ZAR, currencyNumber: 710 },
};
